import type { TLink, TLinkResult } from "@hsr/types";

// helper function for cleanup graphql responses
// normalizes links (color & icon results can be empty)
export const normalizeLinks = (links: TLinkResult[]): TLink[] => {
  const normalized = links.map((item) => {
    return {
      ...item,
      icon: item?.icon?.results[0] || undefined
    };
  });

  return normalized;
};

// XM Cloud: helper function for normalizing locales (de -> de/DE)
export const normalizeLocale = (lng: string): string => {
  switch (lng) {
    case "de":
      return "de-DE";
    case "en":
      return "en";
    default:
      return lng;
  }
};

// Content Hub: helper function for normalizing locales (de -> de-DE)
export const normalizeCHLocale = (lng: string): string => {
  switch (lng) {
    case "de":
      return "de-DE";
    case "en":
      return "en-US";
    default:
      return lng;
  }
};
